import { createSlice } from "@reduxjs/toolkit";

/**
 * Estado del workspace Mi Puesto: pestañas activas del cargo y solicitudes
 * de cambio de pestaña. Permite que la navegación inducida (drill-down de
 * dashboards) cambie de PESTAÑA cuando el destino vive dentro del puesto,
 * en vez de sacar al usuario al menú de procesos.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-08-04
 */
const mipuestoSlice = createSlice({
  name: "mipuesto",
  initialState: {
    // [{ PESTORDX, moduleUrl, processUrl }] — vacío = puesto no montado
    pestanas: [],
    // PESTORDX solicitada por la navegación inducida
    tabSolicitada: null,
  },
  reducers: {
    setMipuestoPestanas: (state, action) => {
      state.pestanas = action.payload;
    },
    setTabSolicitada: (state, action) => {
      state.tabSolicitada = action.payload;
    },
    clearMipuesto: (state) => {
      state.pestanas = [];
      state.tabSolicitada = null;
    },
  },
});

export const { setMipuestoPestanas, setTabSolicitada, clearMipuesto } = mipuestoSlice.actions;

export const getMipuestoPestanas = (state) => state.mipuesto.pestanas;
export const getTabSolicitada = (state) => state.mipuesto.tabSolicitada;

export default mipuestoSlice.reducer;
